import { Link } from "@inertiajs/react";
import { FiArrowRight } from "react-icons/fi";
import { LuFileCheck } from "react-icons/lu";

export default function ParanaClubeThanksPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#c8fdd3] p-[8px]">
      <div className="flex h-[calc(100vh-16px)] w-full flex-col items-stretch gap-[8px] md:flex-row">
        {/* Hero section */}
        <div className="relative hidden h-52 items-center justify-center overflow-hidden rounded-[32px] pr-[32px] sm:flex sm:h-auto sm:w-1/2">
          {/* Background image */}
          <img
            style={{ background: "repeating-conic-gradient(#000 0 0.0001%,#0000 0 0.0002%)" }}
            src="/solarPanelLandingPage.jpeg"
            alt=""
            className="absolute inset-0 size-full object-cover"
          />

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-[rgba(28,65,137,0.4)] to-[#1c4189]" />

          {/* Logo and branding */}
          <div className="h-54 relative z-10 flex items-center gap-[17.3px]">
            <img src="/images/geedee-by-brp-white.png" alt="Geedee" className="h-12" />
          </div>
        </div>

        {/* Success card */}
        <div className="flex flex-1 flex-col items-center justify-center rounded-[32px] bg-[#183f38] p-6 sm:p-[56px]">
          <div className="flex w-full max-w-[496px] flex-1 flex-col justify-center gap-[32px]">
            {/* Success icon */}
            <div className="relative flex size-[120px] shrink-0 items-center justify-center rounded-[80px] bg-[#76fa91]">
              <LuFileCheck className="text-[#183f38]" size={48} />
            </div>

            {/* Success message */}
            <div className="flex w-full flex-col gap-[8px]">
              <h1 className="text-[40px] font-normal leading-[1.2] text-white">
                Tudo certo por aqui!
              </h1>
              <div className="flex flex-col gap-[8px]">
                <p className="text-[16px] font-normal leading-[1.6] text-[#d3d8db]">
                  Nossa equipe está analisando suas informações para verificar sua elegibilidade e
                  estimar seu desconto mensal na conta de energia.
                </p>
                <p className="text-[16px] font-normal leading-[1.6] text-[#d3d8db]">
                  Você receberá o retorno em breve pelo e-mail ou celular informado.
                </p>
              </div>
            </div>

            {/* Back to home link */}
            <div className="flex w-full flex-1 items-end">
              <Link
                href="/"
                className="flex h-[32px] items-center gap-[8px] text-[16px] font-bold leading-[1.6] text-white hover:underline"
              >
                <span>Voltar para a página inicial</span>
                <FiArrowRight size={24} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
